/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_TypeInputs */



/**
* | output |
* | --- |
* | "Type" |
*
* @param {Manual_Qc_Export_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_type = /** @type {((inputs?: Manual_Qc_Export_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type")
	if (locale === "de") return /** @type {LocalizedString} */ ("Typ")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo")
	return /** @type {LocalizedString} */ ("Type")
});